import React, { useEffect, useRef } from 'react';
import p5 from 'p5';




const Bloom = () => {
  const sketchRef = useRef(null);
  const p5Instance = useRef(null); // Add ref to store p5 instance
  let dragStartX = 0;
  let dragStartY = 0;
  let rotationStartX = 0;
  let rotationStartY = 0;
  let cameraRotationX = 0;
  let cameraRotationY = 0;
  let isDragging = false;
  let cameraDistance = 400;
  const MIN_ZOOM = -1000;
  const MAX_ZOOM = 1000;
  const ZOOM_SENSITIVITY = 0.1
  let attempCount = 0; 


  const createSketch = (p) => {

    p.frameRate(30); // Limit to 30fps instead of trying to run at 60+
    // State variables
    let state = {
      current: 0,
      x: 0,
      y: 0,
      opacity: 0,
      opacityState: 2,
      clock: 0,
      rotationX: p.random(0, p.TWO_PI), // Random rotation around X-axis
      rotationY: p.random(0, p.TWO_PI), // Random rotation around Y-axis
      rotationZ: p.random(0, p.TWO_PI),
      vectors: Array(6).fill(0),
      colors: [
        p.color(201, 5, 3), p.color(201, 5, 3),
        p.color(123, 165, 178), p.color(229, 177, 173),
        p.color(70, 51, 39), p.color(255, 1, 47),
        p.color(246, 177, 148), p.color(150, 11, 3),
        p.color(32, 35, 0), p.color(138, 87, 83),
        p.color(244, 242, 91), p.color(236, 196, 64),
        p.color(150, 69, 32), p.color(208, 206, 93),
        p.color(238, 8, 1), p.color(52, 178, 56),
        p.color(255, 249, 78), p.color(107, 92, 44),
        p.color(159, 134, 32), p.color(254, 180, 16),
        p.color(231, 237, 190), p.color(212, 72, 0),
        p.color(199, 128, 25), p.color(136, 75, 62)
      ],
      settings: {
        circleHeight: 10,
        circleWidth: 0.1,
        circleSize: 0.1,
        circleDensity: 10,
        iterations: 50,
        iterations2: 50,
        colorScheme: 1,
        triangleType: 4,
        circleType: 1,
        amount: 500,
        lineWidth: 1,
        flicker: 3,
        rotateSpeed_x: 200000,
        rotateSpeed_y: 200000,
        rotateSpeed_z: 200000,
        backgroundClear: 2,
        dir: 1.0,
        space: 1,
        randomSpace: 1,
        randomSpace2: 1,
        color1: 8,
        color2: 3,
        color3: 300,
        randColor: null,
        randColorR: 0,
        randColorG: 0,
        randColorB: 0
      }
    };

    const randomizeSettings = () => {
        state.settings.rotateSpeed_x = p.random(20000, 50000); 
        state.settings.rotateSpeed_y = p.random(20000, 50000); 
        state.settings.rotateSpeed_z = p.random(20000, 50000); 

        state.settings.lineWidth = p.random(0.1, 0.3); 
        state.settings.colorScheme = p.floor(p.random(1, 13)); 
        state.settings.circleHeight = p.random(0.1, 10.0); 
        state.settings.circleWidth = p.random(0.1, 10.0); 
        state.settings.circleSize = p.random(0.01, 1.34);
        state.settings.circleDensity = p.random(1, 100); 
        state.settings.triangleType = p.floor(p.random(1, 8)); 
        state.settings.circleType = p.floor(p.random(1, 9));

        state.settings.iterations = p.floor(p.random(60)) + 20; 
        state.settings.iterations2 = state.settings.iterations > 30 
          ? p.floor(p.random(45)) + 30 
          : p.floor(p.random(45)) + 50; 
        state.settings.backgroundClear = p.floor(p.random(0, 8)); 
        state.settings.color1 = p.random(0, 50.0); 
        state.settings.color2 = p.random(0.1, 5.0); 
        state.settings.color3 = p.random(10, 800); 
        const randColor = state.colors[p.floor(p.random(state.colors.length))];
        state.settings.randColor = randColor;       
        state.settings.randColorR = p.red(randColor);
        state.settings.randColorG = p.green(randColor);
        state.settings.randColorB = p.blue(randColor);

        state.settings.randomSpace = p.random(0.1, 10.0); 
        state.settings.randomSpace2 = p.random(0.1, 2.0); 
        state.settings.rotationX = p.random(-Math.PI, Math.PI); 
        state.settings.rotationY =p.random(-Math.PI, Math.PI);  
        state.settings.rotationZ =p.random(-Math.PI, Math.PI); 
        
        console.log("color scheme = ",  state.settings.colorScheme); 

        state.vectors = Array(6).fill(0).map(() => p.random(-40, 40));
      // p.camera(0, 0, 100, 0, 0, 0, 0, 1, 0);

      state.settings.dir = p.random(-0.2, 0.2);
      state.settings.space = state.settings.randomSpace;
      state.y = state.settings.amount;
      state.x = 0;
    };

    const updateOpacity = () => {
      const fadeSpeed = 255.0 / (30 * 10);
      
      if (state.opacityState === 0) {
        state.opacity += fadeSpeed;
        if (state.opacity >= 255) {
          state.opacity = 255;
          state.opacityState = 1;
          state.clock = 0;
        }
      } else if (state.opacityState === 1) {
        state.clock++;
        state.opacity = 255;
        if (state.clock >= 40 * 20) {
          state.opacityState = 2;
        }
      } else if (state.opacityState === 2) {
        state.opacity -= fadeSpeed;
        if (state.opacity <= 0) {
          state.opacity = 0;
          state.opacityState = 0;
          randomizeSettings();
        }
      }
    };

    const customOrbitControl = () => {
      if (p.mouseIsPressed) {
        if (!isDragging) {
          dragStartX = p.mouseX;
          dragStartY = p.mouseY;
          rotationStartX = cameraRotationX;
          rotationStartY = cameraRotationY;
          isDragging = true;
        }

        const sensitivity = 0.001;
        const deltaX = (p.mouseX - dragStartX) * sensitivity;
        const deltaY = (p.mouseY - dragStartY) * sensitivity;

        cameraRotationY = rotationStartY + deltaX;
        cameraRotationX = rotationStartX + deltaY;
      } else {
        isDragging = false;
      }
    };



    const setColorScheme = (i, k) => {
      const s = state.settings;
      let opacity = state.opacity; 

      if (state.opacity > 255) state.opacity = 255;
    
      // Adjust for halved iterations
      const i2 = i * 2;
      const k2 = k * 2;
    
      switch (s.colorScheme) {
        case 1:
          p.stroke(i2/s.color1*11, i2*s.color2, i2+s.color3+20, opacity);
          break;
        case 2:
          p.stroke(i2+s.color2*15, i2*s.color3/1000, i2/s.color1*27, opacity);
          break;
        case 3:
          p.stroke(i2+s.color3/10, i2/s.color1*10, i2*s.color2*2.7, opacity);
          break;
        case 4:
          p.stroke(i2/s.color1*11+(state.x/10), i2*s.color2-(state.y/4), i2+s.color3-(state.y/12), opacity);
          break;
        case 5:
          p.stroke(i2/s.color1*5+k2, i2*s.color2-k2, i2+s.color3*k2/8, opacity);
          break;
        case 6:
          p.stroke(i2+s.color2*15/k2, i2*s.color3/1000-k2, i2/s.color1*k2, opacity);
          break;
        case 7:
          p.stroke(i2+s.color3/15+k2, i2/s.color1+(k2/20), i2*s.color2*3.0-k2, opacity);
          break;
        case 8:
          p.stroke(i2/s.color1*11+(k2/2), i2*s.color2-(k2/4), i2+s.color3-(k2/12), opacity);
          break;
        case 9:
          p.stroke(i2*s.randColorR/10-k2, i2*s.randColorG/10-k2, i2*s.randColorB/10-k2, opacity);
          break;
        case 10:
          p.stroke(i2+s.randColorR+15/k2, i2+s.randColorG*15/k2, i2+s.randColorB*15/k2, opacity);
          break;
        case 11:
          p.stroke(i2/s.randColorR*10, i2+s.randColorG, i2+s.randColorB+(k2/10), opacity);
          break;
        case 12:
          p.stroke(i2+s.randColorR*15/k2, i2+s.randColorG*15/k2, i2+s.randColorB*15/k2, opacity);
          break;
      }
    };

    const drawShape = (i, k) => {

      const s = state.settings;
      const [v1, v2, v3, v4, v5, v6] = state.vectors;

      setColorScheme(i, k);
      p.noFill();

      if (s.flicker === 1 || s.flicker === 2) {
        p.strokeWeight(p.random(s.lineWidth));
      } else {
        p.strokeWeight(s.lineWidth);
      }

      switch (s.triangleType) {
        case 1:
          p.triangle(
            (v1+(state.x/2)+k)*s.dir, (v2-k-(i/5)-(state.y/2)),
            (v3-i+state.y/(k+1)/5)*s.dir, (v4+i-(state.y/2)),
            (v5+i)*s.dir, (v6-i+(state.y/2))
          );
          break;
        case 2:
          p.triangle(
            (v1-(state.x)-k*2)*s.dir, (v2-k-(i/5)+(state.y/2)),
            (v3-i+state.y/(k+1)/5)*s.dir, (v4+i-(state.y/2)),
            (v5+i)*s.dir, (v6+i+(state.y/2))
          );
          break;
        case 3:
          p.triangle(
            (v1-(state.x/2)+k)*s.dir, (v2-k+(i/1)-(state.y)),
            (v3+i+state.y/(k+1)/5)*s.dir, (v4-i+(state.y/2)),
            (v5-i)*s.dir, (v6+i-(state.y/2))
          );
          break;
        case 4:
          p.triangle(
            (v1+(state.x/2)-k)*s.dir, (v2+k+(i/1)+(state.y/2)),
            (v3+i-state.y/(k+1)/5)*s.dir, (v4+(i/10)+(state.y/2)),
            (v5-i)*s.dir, (v6+i+(state.y/2))
          );
          break;
        case 5:
          p.triangle(
            (v1+(state.x/2)+(k+1))*s.dir, (v2+k-(i/5)-(state.x/2)),
            (v3+i+state.y/(k+1)/5)*s.dir, (v4-(i/5)-(state.x/2)),
            (v5+i+state.y)*s.dir, (v6-i-(state.x/2))
          );
          break;
        case 6:
          p.bezier(
            v1+(k/2), v2-i, v2-k, v3+i+state.y,
            v4+state.y-(i/2), v5+(i/2), v6-(state.y/2), v6+state.y/2
          );
          break;
        case 7:
          p.bezier(
            v1-(k/2), v2+(i/2), v2+k, v3-i-state.y,
            v4-state.y+(i/2), v5+(i/3), v6+(state.y/2), v6-state.y/2
          );
          break;
      }

      switch (s.circleType) {
        case 1:
          p.arc((v1+10+k+(state.x/2)), v2, k*s.circleHeight, k*s.circleWidth,
               k/s.circleDensity, k/s.circleDensity+s.circleSize);
          break;
        case 2:
          p.arc((v1-10+k-(state.x/2)), v2, k*s.circleHeight, k*s.circleWidth,
               k/s.circleDensity, k/s.circleDensity+s.circleSize);
          break;
        case 3:
          p.arc((v1+10+k+(state.x/2)), v2, k+s.circleHeight*state.y/5,
               k+s.circleWidth*state.y/5, k/s.circleDensity,
               k/s.circleDensity+s.circleSize);
          break;
        case 4:
          p.arc((v1+10-k-(state.x/3)), v2, k*s.circleHeight*2, k*s.circleWidth*2,
               k/s.circleDensity/1.1, k/s.circleDensity+s.circleSize);
          break;
        case 5:
          p.arc((v1+10-k+(state.x/2)), v2, k*s.circleHeight*state.x/15,
               k*s.circleWidth*state.x/15, k/s.circleDensity,
               k/s.circleDensity+s.circleSize);
          break;
        case 6:
          p.line((v1+10-k+(state.x/2)), v2, k*s.circleHeight*state.x/15,
                k*s.circleWidth*state.x/15, k/s.circleDensity,
                k/s.circleDensity+s.circleSize);
          break;
        case 7:
          p.rect((v1+10-k+(state.x/50)), v2, k*s.circleHeight*(state.x/25),
                k*s.circleWidth*(state.x/100));
          break;
        case 8:
          p.bezier(v1+(i/3), v2-(k/2), v3+(k/3), (v2-(state.x/20)),
                  v4+(state.y/50), v5*k, v6-(state.x/10), v6-(state.y/20));
          break;
      }
      
    };

    let cam;
    let fps; 

    p.setup = () => {
      p.pixelDensity(1); // Force 1x pixel density
      p.createCanvas(p.windowWidth, p.windowHeight, p.WEBGL);  
      //p.canvas.style.position = 'absolute';
            p.noSmooth(); // Disable antialiasing for better performance

      
      cam = p.createCamera();
      randomizeSettings();
    };



    p.draw = () => {

      fps = p.frameRate();
      // console.log(fps);  // Logs the value of myVariable to the console
      state.x += 0.05;
      state.y -= 0.05;
      // p.orbitControl(); // Add simple interactive camera control
      customOrbitControl();
      p.translate(0, 0, cameraDistance);  // Apply zoom
      p.rotateX(cameraRotationX);
      p.rotateY(cameraRotationY);     
      updateOpacity();
      
      if(fps < 20)
      {
        // console.log("fps low af"); 
        if(state.settings.iterations > 5)
        {
          // console.log("Iterations1 = ", state.settings.iterations); 

          state.settings.iterations -= 1; 
        }

        if(state.settings.iterations2 > 5)
          // console.log("Iterations2 = ", state.settings.iterations2); 
        {
          state.settings.iterations2 -= 1; 
        }
        attempCount +=1;
        if(attempCount >= 5)
        {
          randomizeSettings(); 
        }
      } else
      {
        attempCount = 0; 
      }



      // if (!(state.settings.backgroundClear === 1 && state.y > 1)) {
        p.background(0);
    // }

    // p.translate(p.width/2, p.height/2);
    p.push();


      const rotationFactor_x = state.x / state.settings.rotateSpeed_x;
      const rotationFactor_y = state.x / state.settings.rotateSpeed_y;
      const rotationFactor_z = state.x / state.settings.rotateSpeed_z;

      let rotatationY = state.rotationY + rotationFactor_x; 
      let rotatationX = state.rotationX + rotationFactor_y; 
      let rotatationZ = state.rotationZ * 0.1 + rotationFactor_z; 
      for (let i = 0; i < state.settings.iterations; i += state.settings.randomSpace2) {
        for (let k = 0; k < state.settings.iterations2; k += state.settings.space) {
          p.rotateY(rotatationY);
          p.rotateX(rotatationX);
          p.rotateZ(rotatationZ);
          drawShape(i, k);

        }
      }
    
      p.pop();

  };

  p.windowResized = () => {
    p.resizeCanvas(p.windowWidth, p.windowHeight);
  };

  // Updated mouseWheel handler for subtle zoom
  p.mouseWheel = (event) => {
    event.preventDefault();
    const delta = event.delta;
    // Apply subtle zoom with constraints
    cameraDistance = p.constrain(
      cameraDistance + (delta * ZOOM_SENSITIVITY),
      MIN_ZOOM,
      MAX_ZOOM
    );
    return false;
  };
};



useEffect(() => {

    // Cleanup any existing instance
    if (p5Instance.current) {
      p5Instance.current.remove();
    }

    // Create new instance
    if (sketchRef.current) {
      p5Instance.current = new p5(createSketch, sketchRef.current);
    }

    // Cleanup on unmount
    return () => {
      if (p5Instance.current) {
        p5Instance.current.remove();
        p5Instance.current = null;
      }
    };
  }, []); // Empty dependency array ensures this runs once on mount

  return (
    <div ref={sketchRef} className="w-full h-screen" style={{ background: 'black' }} />
  );
};

export default Bloom;
